import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { equals } from 'ramda'
import { Loader, Div } from '@driftt/tide-core'

import { getReportDataByID } from 'api/playbooks'
import EmailPerformance from 'components/Reports/EmailPerformance/EmailPerformanceTab'
import { delay } from 'utils'
import { fetchSignatureClickMap } from 'modules/playbooks/actions'
import * as PlaybookSelectors from 'modules/playbooks/selectors'


import './styles.css'

class SignatureReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      totalStats: null,
      isLoading: true,
      hasLoaded: false,
      clickMapIsLoading: true,
      clickMaphasLoaded: false,
    }
  }

  componentDidMount() {
    this.getPlaybookStats()
    this.getClickMapStats()
  }

  componentDidUpdate(prevProps) {
    if (!equals(this.props, prevProps)) {
      this.setState({ hasLoaded: true, isLoading: true, totalStats: null })
      this.getPlaybookStats()
      this.getClickMapStats()
    }
  }

  refetchStats = () => {
    this.setState({
      isLoading: true,
    }, this.getPlaybookStats)
  }

  getPlaybookStats = async () => {
    const { id } = this.props.playbook
    const { currentDateRange, previousDateRange } = this.props
    const [ startDate, endDate ] = currentDateRange
    const [ prevStartDate, prevEndDate ] = previousDateRange

    try {
      const { data } = await getReportDataByID(id, { startDate, endDate, prevStartDate, prevEndDate }, 'signature')
      this.setState({totalStats: data, isLoading: false}, this.setHasLoaded)
    } catch (error) {
      console.log(error)
    }
  }

  getClickMapStats = async () => {
    const { id } = this.props.playbook
    const { currentDateRange, orgId } = this.props
    const [ startDate, endDate ] = currentDateRange

    try {
      this.props.fetchSignatureClickMap({playbookId: id, startDate, endDate, orgId})
    } catch (error) {
      console.log(error)
    }
  }

  setHasLoaded = async () => {
    const setLoaded = () => {
      this.setState({
        hasLoaded: true
      })
    }

    const setComplete = () => {
      this.setState({
        isLoading: false
      })
    }

    setLoaded()
    delay(setComplete, 1000)
  }

  render() {
    const {
      isLoading,
      hasLoaded,
      totalStats,
    } = this.state

    const {
      currentDateRange,
      previousDateRange,
      playbook,
      clickMapData,
    } = this.props

    return (
      <Div className="reports-container">
        {isLoading &&
          <Div className="playbook-report-loader">
            <Loader height={200} width={200} />
          </Div>
        }
        {hasLoaded &&
          <Fragment>
            <EmailPerformance
              id={playbook.id}
              data={totalStats}
              playbook={playbook}
              clickMapData={clickMapData}
              playbookReportType="signature"
              dateRanges={{current: currentDateRange, previous: previousDateRange}}
            />

          </Fragment>
        }
      </Div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orgId: state.org.id,
    salesForceRevenue: state.org.properties.salesforceRevenueMetricsEnabled,
    clickMapData: PlaybookSelectors.clickMap(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSignatureClickMap: (params) => {
      dispatch(fetchSignatureClickMap(params))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignatureReport)
